import { BadgeCheck } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@primitives/toggle-group";
import { useTranslation } from "react-i18next";

/**
 * The Language settings body (language toggle group). Rendered by LanguageTab
 * (legacy accordion) and SettingsCategoryView (flag `settingsMiddleViews`).
 * Layout-neutral — the host owns the wrapper.
 */
export default function LanguageContent() {
  const { i18n } = useTranslation();
  // normalize code to match (e.g., en-US -> en)
  const currentLang = i18n.language.split("-")[0];

  const languages: { code: string; label: string }[] = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
    // { code: "fr", label: "Français" },
    // { code: "ro", label: "Română" },
    // { code: "de", label: "Deutsch" },
  ];

  return (
    <ToggleGroup
      type="single"
      value={currentLang}
      onValueChange={(value) => {
        if (value) {
          i18n.changeLanguage(value);
        }
      }}
      className="flex flex-col p-0"
    >
      {languages.map((lang) => (
        <ToggleGroupItem
          key={lang.code}
          value={lang.code}
          aria-label={lang.label}
          className="flex w-full items-center justify-start rounded-md px-3 py-2 text-accent-foreground data-[state=on]:bg-transparent data-[state=off]:text-accent-foreground/50 data-[state=on]:text-accent-foreground"
        >
          <span>{lang.label}</span>
          <BadgeCheck className="ml-auto size-5 data-[state=on]:inline data-[state=off]:hidden" />
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
